<template>
  <b-modal
    :title="'Detalle Solicitud de Materiales'"
    id="addMaterials"
    size="xl"
    v-model="showModal"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    @close="onModalClose()"
    ref="fromRequestDetailModal"
  >
    <div class="row scroll">
      <div class="col-12">
        <h5 class="text-primary">
          Esta solicitud ha sido creada por {{ requestDetail.name || '-'}}
        </h5>
      </div>
      <div class="col-12" style="margin: 0 auto;">
        <div class="row">
          <div class="shadow col-4">
            <vs-list>
              <vs-list-item
                icon="description"
                :title="requestDetail.numero.padStart(7, '0') || '-'"
                subtitle="Folio"
              />
              <vs-list-item
                icon="person"
                :title="requestDetail.name || '-'"
                subtitle="Creador"
              />
              <vs-list-item
                icon="event"
                :title="this.$moment(requestDetail.createdAt).format('YYYY-MM-DD') || '-'"
                subtitle="Fecha de Creación Solicitud"
              />
              <vs-list-item
                icon="info"
                :title="requestDetail.statusDescription || '-'"
                subtitle="Estado Solicitud"
              />
            </vs-list>
          </div>
          <div class="shadow col-4">
            <vs-list>
              <vs-list-item
                icon="event"
                :title="requestDetail.dateRequest || '-'"
                subtitle="Fecha de Solicitud"
              />
              <vs-list-item
                icon="event"
                :title="requestDetail.dateRequestEnd || '-'"
                subtitle="Fecha de Retiro"
              />
            </vs-list>
          </div>
          <div class="shadow col-4">
            <vs-list>
              <vs-list-item
                icon="person"
                :title="requestDetail.request || '-'"
                subtitle="Nombre Solicitud"
              />
              <vs-list-item
                icon="description"
                :title="requestDetail.description || '-'"
                subtitle="Descripción Solicitud"
              />
              <vs-list-item
                icon="attach_money"
                :title="requestDetail.precioSolicitudTotal || '-'"
                subtitle="Monto Final"
              />
            </vs-list>
          </div>
        </div>
      </div>
      <vs-divider />
      <div class="col-12">
        <h5 class="text-primary">
          Detalle Solicitud
        </h5>
        <div class="row mt-3">
          <div class="col-12">
            <b-list-group
              v-for="(request) of requests"
              :key="request.id"
            >
              <b-list-group-item
                :v-b-toggle="'accordion-' + request.id"
                button
                role="tab"
                :key="request.id"
                @click="onActiveAccordion(request.id)"
              >
                <div class="row">
                  <div class="col-11">
                    {{ request.name }}
                  </div>
                  <div class="col-1">
                    <em
                      v-if="isAccordionOpen && activeAccordionId === request.id"
                      class="fa fa-chevron-down"
                    ></em>
                    <em
                      v-else
                      class="fa fa-chevron-up"
                    ></em>
                  </div>
                </div>
              </b-list-group-item>
              <div class="row">
                <div class="ml-5 mr-5">
                  <b-collapse
                    :id="'accordion-' + request.id"
                    accordion="my-accordion"
                    role="tabpanel"
                    block
                    :visible="isAccordionOpen && activeAccordionId === request.id"
                  >
                    <b-table
                      :fields="fieldMaterialsRequestDetail"
                      :items="request.materials"
                      sticky-header
                      :key="'table-' + request.id"
                      :id="'table-' + request.id"
                      primary-key="id"
                      fixed responsive
                    >
                      <template #cell(categoria)="row">
                        {{ row.item.categoria[0].descripcion || '' }}
                      </template>
                      <template #cell(marca)="row">
                        {{ row.item.marca.descripcion }}
                      </template>
                      <template #cell(precio)="row">
                        {{ parseInt(row.item.precio) | toCurrency }}
                      </template>
                      <template #cell(totalSolicitar)="row">
                        {{ parseInt(row.item.totalSolicitar) | toCurrency }}
                      </template>
                    </b-table>
                  </b-collapse>
                </div>
              </div>
            </b-list-group>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PopUpRequestDetail',
  data() {
    return {
      requestDetail: [],
      requests: [],
      activeAccordionId: '',
      isAccordionOpen: false,
    };
  },
  beforeUpdate() {
    this.requestDetail = this.materialRequestsDetail;
    this.requests = this.materialRequestsDetail.detail;
  },
  mounted() {
    this.requestDetail = this.materialRequestsDetail;
    this.requests = this.materialRequestsDetail.detail;
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Materials', [
      'materialRequestsDetail',
      'fieldMaterialsRequestDetail'
    ]),
    showModal: {
      get() {
        return this.modalName === 'PopUpRequestDetail';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    onModalClose() {
      this.closeModal();
    },
    onActiveAccordion(request) {
      if (this.activeAccordionId !== request) {
        this.isAccordionOpen = true;
        this.activeAccordionId = request;
      } else {
        this.isAccordionOpen = !this.isAccordionOpen;
      }
    },
  }
};
</script>
